import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner,Input,FormFeedback,Form } from 'reactstrap';
import { changePasswordUser } from '../../../helpers/backend_helper';
import { getStorageUser } from '../../../helpers/api_helper';
import {Alert} from '../../../helpers/alerts/alertHelper';
import * as Yup from "yup";
import { useFormik } from "formik";

const UpdatePassw = ({modal,setModal}) => {
	const [ errors, setErrors ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const authUser = getStorageUser();
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {password:'',password_confirmation:'',id:modal.id? modal.id:authUser.id},
		validationSchema: Yup.object({
			password:Yup.string().required('Ingresa una nueva contraseña').min(8),
			password_confirmation:Yup.string().required('Required').oneOf([Yup.ref('password')], 'Las contraseñas no coinciden'),
		}),
		onSubmit: async values => {
			await save(values)
		},
	});

	const save = async(data) => {
    	setLoading(true)
    	const response = await changePasswordUser(data.id,data)
    	if(response.status){
    		setLoading(false)
    		setModal({show:false})
    	}else{
    		setLoading(false)
    	}
    	
    }

    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-primary">Editar Contraseña</ModalHeader>
				<Form
					onSubmit={e => {
					e.preventDefault();
					validation.handleSubmit();
					return false;
					}}
				>
				<ModalBody>
					<div className="row">
						<div className="col-sm-12">
							<label className="form-label">Contraseña:</label>
							<Input
								name="password"
								type="password"
								onChange={validation.handleChange}
								onBlur={validation.handleBlur}
								value={validation.values.password || ""}
								invalid={
									validation.touched.password &&
									validation.errors.password
									? true
									: false
								}
							/>
						    {(validation.touched.password && validation.errors.password) && <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>}
						    {errors && <div className="form-text text-danger">{errors.password && errors.password[0]}</div>}
						</div>
						<div className="col-sm-12">
							<label className="form-label">Repite Contraseña:</label>
							<Input
								name="password_confirmation"
								type="password"
								onChange={validation.handleChange}
								onBlur={validation.handleBlur}
								value={validation.values.password_confirmation || ""}
								invalid={
									validation.touched.password_confirmation &&
									validation.errors.password_confirmation
									? true
									: false
								}
							/>
						    {(validation.touched.password_confirmation && validation.errors.password_confirmation) && <FormFeedback type="invalid">{validation.errors.password_confirmation}</FormFeedback>}
						    {errors && <div className="form-text text-danger">{errors.password_confirmation && errors.password_confirmation[0]}</div>}
						</div>
					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" type='submit' disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } 
						<i className='fa fa-save'></i> Guardar
					</Button>{' '}
					<Button color="secondary" onClick={()=>setModal({show:false})}>
						<i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
				</Form>
	        </Modal>
		</div>
	);
}

export default UpdatePassw;